import React from 'react';
import styled from 'styled-components';

const Break = styled.div`
    height: 2px;
    width: 100%;
    margin: ${({ theme }) => theme.margin.med} auto;
    /* margin-bottom: ${({ theme }) => theme.margin.lrg}; */
    margin-bottom: 0;
    background: ${({ theme }) => theme.color.scLightGray4};
    border-top: 1px solid ${({ theme }) => theme.color.scLightGray2};
    border-left: 1px solid ${({ theme }) => theme.color.scLightGray2};
    border-bottom: 1px solid ${({ theme }) => theme.color.scLightGray3};
    border-right: 1px solid ${({ theme }) => theme.color.scLightGray3};
`;

export { Break };



// WEBPACK FOOTER //
// ./src/sc-ui/Break.jsx